import { render, staticRenderFns } from "./ImptBsnesAgencInfoMain.vue?vue&type=template&id=17071f08"
import script from "./ImptBsnesAgencInfoMain.vue?vue&type=script&lang=js"
export * from "./ImptBsnesAgencInfoMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17071f08')) {
      api.createRecord('17071f08', component.options)
    } else {
      api.reload('17071f08', component.options)
    }
    module.hot.accept("./ImptBsnesAgencInfoMain.vue?vue&type=template&id=17071f08", function () {
      api.rerender('17071f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/ImptBsnesAgencInfoMain.vue"
export default component.exports